"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountLogin = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var AccountLoginAction_1 = require("@/pages/accountLogin/actions/AccountLoginAction");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var Login_1 = require("@/pages/common/components/Login");
var mapStateToProps = function (state) { return (__assign({}, state.accountLogin)); };
var mapDispatchToProps = function (dispatch) { return ({
    onLoginSubmit: function () { return dispatch(AccountLoginAction_1.default.onLoginSubmit()); },
}); };
exports.accountLogin = function (props) {
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { className: "l-container__bg", style: { backgroundColor: '#000' } },
            React.createElement("img", { src: "https://images.okay.com/website/common/images/home-bg1.jpg", alt: "", style: { opacity: 0.7 } })),
        React.createElement("div", { className: "l-container l-container--rightmain" },
            React.createElement("div", { className: "l-container__side" }),
            React.createElement("div", { className: "l-container__main" },
                React.createElement(Login_1.default, { persist: true })))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.accountLogin);
